'use client';

import { useState, useEffect } from 'react';

// A placeholder for the logo to match the visuals.
const ZamziConnectLogo = ({ className }: { className?: string }) => (
  <div className={className}>
      <h1 className="text-6xl font-bold drop-shadow-md" style={{ fontFamily: `'Poppins', sans-serif` }}>
          <span style={{ color: '#4CAF50' }}>Z</span>
          <span style={{ color: '#FFC107' }}>a</span>
          <span style={{ color: '#F44336' }}>m</span>
          <span style={{ color: '#2196F3' }}>z</span>
          <span style={{ color: '#E91E63' }}>i</span>
      </h1>
      <p className="mt-1 text-sm tracking-[0.2em] text-gray-200 drop-shadow-xs">BE FOUND. BE TRUSTED. BE CHOSEN.</p>
  </div>
)

interface ComingSoonBannerProps {
  showX?: boolean;
}

export function ComingSoonBanner({ showX = false }: ComingSoonBannerProps) {
  const [isVisible, setIsVisible] = useState(true);
  const [mounted, setMounted] = useState(false);

  // Use useEffect to detect when the component has successfully loaded on the client
  useEffect(() => {
    setMounted(true);
  }, []);

  // 1. If we aren't mounted yet, return null to avoid hydration errors
  // 2. If the user clicked the X, return null
  if (!mounted || !isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-9999 flex flex-col items-center justify-center bg-linear-to-br from-red-500 via-orange-500 to-red-600 text-white p-4">
      {showX && (
        <button
          aria-label="Close Banner"
          className="absolute top-4 right-4 text-white/70 hover:text-white hover:scale-110 transition-transform"
          onClick={() => setIsVisible(false)}
        >
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
      {/* Removed the animation class temporarily to ensure it's not hiding the element */}
      <div className="text-center">
        <ZamziConnectLogo className="mb-8" />
        <h2 className="text-5xl font-bold tracking-tight text-white drop-shadow-lg sm:text-6xl">
          Coming Soon!
        </h2>
        <p className="mt-6 text-lg leading-8 text-gray-200 drop-shadow-md">
          We're getting ready to connect you, just now!
        </p>
      </div>
    </div>
  );
}
